import { datadogRum } from "@datadog/browser-rum";

/**
 * Success beacon — the payment page reached a functional, rendered state
 * ("loaded successfully"). Emits a Datadog RUM action for observability.
 *
 * NOT tied to payment approval: a later decline is a normal business outcome
 * and does not undo readiness.
 */
export function reportPaymentPageReady(
  detail: Record<string, unknown> = {},
): void {
  try {
    datadogRum.addAction("payment_page_ready", { ...detail });
  } catch {
    /* RUM not initialized / sampled out — safe to ignore. */
  }
}

/**
 * Health FAILURE beacon — component crashes and infrastructure failures ONLY
 * (React crash, lazy-load failure, AxiosError/network, terminals/settings load
 * failure, SignalR could not be established).
 *
 * NEVER call this for a declined or failed payment: a decline is a normal
 * business outcome, not a defect.
 *
 * Emits a Datadog RUM error and action for observability.
 */
export function reportPaymentHealthError(
  source: string,
  error?: unknown,
  context: Record<string, unknown> = {},
): void {
  try {
    datadogRum.addError(error ?? new Error(`payment_health_error:${source}`), {
      errorSource: "payment_component_health",
      source,
      ...context,
    });
    datadogRum.addAction("payment_health_error", {
      source,
      ...context,
    });
  } catch {
    /* RUM not initialized / sampled out — safe to ignore. */
  }
}
